import React from "react";
import { Card } from "react-bootstrap";
import { useIntl } from "react-intl";

import Settings from "./Settings.jsx";

const messages = {
  title: {
    id: "modules.Settings.components.Dashboard.title",
    description: "Dashboard title section",
    defaultMessage: "Settings",
  },
};

const Dashboard = () => {
  const { formatMessage } = useIntl();

  return (
    <Card>
      <Card.Header className="card-header-borderless" as="h3">
        {formatMessage(messages.title)}
      </Card.Header>
      <Card.Body>
        <Settings />
      </Card.Body>
    </Card>
  );
};

export default Dashboard;
